if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

// Custom : Handle cookie management from footer menu
document.addEventListener('DOMContentLoaded', function () {
  const COOKIE_LINK_LABELS = ['Gestion des cookies', 'Cookie management'];

  document.querySelectorAll('.footer__bottom a').forEach(function (link) {
    if (!COOKIE_LINK_LABELS.includes(link.textContent.trim())) return;

    // Accessibility attributes
    link.removeAttribute('href');
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
    link.setAttribute('aria-haspopup', 'dialog');
    link.style.cursor = 'pointer';

    link.addEventListener('click', function (e) {
      e.preventDefault();
      privacyBanner.showPreferences();
    });

    // Keyboard support
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        link.click();
      }
    });
  });
});